import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { If, Then, Else } from 'react-if';

import { boostopiaLogo } from '../imageLoader/images';
import customJs from '../../assets/js/custom';
import useAuth from '../../hooks/useAuth';
import Auth from '../auth/auth';
import { unrankedWhite, divisionWhite } from '../imageLoader/images';
import ShortTpBadge from '../../shared/components/ShortTpBadge';

const Navigation = () => {
  const { user } = useAuth();
  const isLoggedIn = Boolean(user);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    customJs();
  }, []);

  return (
    <>
      <header className="top-h-section">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            <div className="d-flex">
              <Link to="/" className="navbar-brand">
                <img src={boostopiaLogo} alt="Boostopia" />
              </Link>
              <div className="d-none d-sm-block mx-4 m-auto">
                <ShortTpBadge
                  styleObj={{
                    border: 'solid 2px #171630',
                    borderRadius: '0.625rem',
                    backgroundImage: 'linear-gradient(rgba(34, 33, 70, 1), rgba(23, 22, 48, 0.5))',
                  }}
                />
              </div>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              // data-bs-target="#navbarNavDropdown"
              // aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => setMenuOpen(!isMenuOpen)}
            >
              <div className="icon-container">
                <div id="menuicon">
                  <div className="bar bar1"></div>
                  <div className="bar bar2"></div>
                </div>
              </div>
            </button>

            {/* {isMenuOpen && */}
            <div
              className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}
              id="navbarNavDropdown"
            >
              <ul className="navbar-nav">
                <li className="nav-item dropdown m-auto">
                  <Link
                    to="/boosting"
                    className="nav-link dropdown-toggle"
                    id="navbarDropdownMenuLink"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onClick={() => navigate('/boosting')}
                  >
                    BOOSTING&nbsp;
                  </Link>
                  <BoostingDropdown />
                </li>

                <li className="nav-item m-auto ms-3 me-3">
                  <div>
                    <Link className="nav-link" to="/accounts" role="button" aria-expanded="false">
                      ACCOUNT SHOP
                    </Link>
                  </div>
                </li>

                {/* <li className="nav-item">
                  <Link className="nav-link" to="/contact-us">
                    CONTACT US
                  </Link>
                </li> */}

                {/* <li className="nav-item">
                  <Link
                    className="nav-link join-discord-link"
                    to="https://discord.gg/ZMDMzNdVT5"
                  >
                    <svg
                      width="21"
                      height="16"
                      viewBox="0 0 21 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.8199 0.259766C13.6213 0.615453 13.4443 0.982785 13.2899 1.35977C11.7727 1.11982 10.2272 1.11982 8.70992 1.35977C8.55551 0.982785 8.37852 0.615453 8.17992 0.259766C6.75071 0.503967 5.36132 0.941303 4.04992 1.55977C1.70486 4.94405 0.641354 9.05272 1.04992 13.1498C2.57815 14.2986 4.29338 15.1748 6.11992 15.7398C6.53583 15.1904 6.90702 14.6085 7.22992 13.9998C6.63399 13.78 6.06121 13.502 5.51992 13.1698C5.66838 13.071 5.80881 12.9606 5.93992 12.8398C7.51838 13.6001 9.24789 13.9949 10.9999 13.9949C12.7519 13.9949 14.4815 13.6001 16.0599 12.8398C16.1999 12.9598 16.3399 13.0698 16.4799 13.1698C15.9357 13.4994 15.3635 13.7805 14.7699 14.0098C15.0794 14.6323 15.4407 15.2277 15.8499 15.7898C17.6742 15.2268 19.3864 14.3504 20.9099 13.1998C21.3283 9.10197 20.2639 4.98995 17.9099 1.60977C16.6132 0.978503 15.2376 0.524436 13.8199 0.259766ZM7.67992 10.8098C7.1795 10.7738 6.71246 10.5455 6.37684 10.1725C6.04122 9.79962 5.86311 9.31119 5.87992 8.80977C5.86058 8.30768 6.0378 7.81785 6.37393 7.44438C6.71005 7.0709 7.17858 6.84324 7.67992 6.80977C8.18126 6.84324 8.64978 7.0709 8.9859 7.44438C9.32203 7.81785 9.49926 8.30768 9.47992 8.80977C9.49926 9.31185 9.32203 9.80168 8.9859 10.1752C8.64978 10.5486 8.18126 10.7763 7.67992 10.8098ZM14.3199 10.8098C13.8195 10.7738 13.3525 10.5455 13.0168 10.1725C12.6812 9.79962 12.5031 9.31119 12.5199 8.80977C12.5006 8.30768 12.6778 7.81785 13.0139 7.44438C13.3501 7.0709 13.8186 6.84324 14.3199 6.80977C14.8222 6.84074 15.2922 7.06767 15.6289 7.44171C15.9655 7.81576 16.1418 8.30702 16.1199 8.80977C16.1418 9.31251 15.9655 9.80377 15.6289 10.1778C15.2922 10.5519 14.8222 10.7788 14.3199 10.8098Z"
                        fill="white"
                      ></path>
                    </svg>
                    Join discord
                  </Link>
                </li> */}
                <li className="nav-item ms-3">
                  {!isLoggedIn ? (
                    <Link
                      id="loginModel"
                      className="btn btn-outline-light my-hover my-font"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={() => {
                        const name = 'g_state';
                        document.cookie =
                          name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                        window.google?.accounts.id.prompt();
                      }}
                    >
                      CLIENT LOGIN
                    </Link>
                  ) : (
                    <Link className="btn btn-outline-light my-hover my-font" to="/admin/dashboard">
                      <If condition={user.username}>
                        <Then>{user.username?.toUpperCase()}'s </Then>
                        <Else>{user.email ? user.email?.split('@')[0] + 's ' : 'MY '}</Else>
                      </If>
                      AREA
                    </Link>
                  )}
                </li>
              </ul>
            </div>
            {/* }  */}
          </div>
        </nav>
      </header>
      <Auth />
    </>
  );
};

const BoostingDropdown = () => {
  return (
    <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
      <li>
        <Link className="dropdown-item" to="/boosting/?tab=division">
          <img src={divisionWhite} width="24px" height="24px" alt="White Division icon" /> DIVISIONS
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/boosting/?tab=net-wins">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="16"
            fill="white"
            className="bi bi-trophy-fill"
            viewBox="0 0 16 16"
          >
            <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935z" />
          </svg>{' '}
          NET WINS
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/boosting/?tab=placement">
          <img src={unrankedWhite} width="24px" height="24px" alt="unranked icon" /> PLACEMENT{' '}
        </Link>
      </li>
    </ul>
  );
};

export default Navigation;
